import React, { useState } from "react";
import SalaryTemplateEarningList from "./SalaryTemplateEarningList";
import AddSalaryTemplate from "./AddSalaryTemplate";
import {useGetPayrollPolicy} from "../../queries/payrollQuries";
import EmptyState from "../../components/EmptyState";
import PageLoader from "../../components/PageLoader";
const SalaryTemplates = () => {
  const [openModal, setOpenModal] = useState(false);
  const { data, isLoading, isError, refetch } = useGetPayrollPolicy();
  const payrollPolicyList = data?.data || []; 

  return (
    <div className="w-full">
      <div className="flex items-center justify-between px-10 pb-4 mt-8">
        <div>
          <h2>Salary Templates</h2>
        </div>
        <div>
          <button 
            className="btn text-[14px]" 
            onClick={() => setOpenModal(true)}
          >
            Add Template
          </button>
        </div>
      </div>
      {/* SalaryTemplateEarningList */}
      {isLoading ? (
        <PageLoader />
      ) : isError || payrollPolicyList.length === 0 ? (
        <EmptyState />
      ) : (
        <SalaryTemplateEarningList payrollPolicyList={payrollPolicyList} />
      )}
      
      {/* AddSalaryTemplate Modal */}
      <AddSalaryTemplate openModal={openModal} onCloseModal={() => setOpenModal(false)} />
    </div>
  );
};

export default SalaryTemplates;
